<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import AppHeader from '@/components/AppHeader.vue'

const route = useRoute()
const blankLayout = computed(() => route.meta.layout === 'blank')
</script>

<template>
  <template v-if="blankLayout">
    <router-view />
  </template>
  <template v-else>
    <AppHeader />
    <main class="app-main">
      <router-view />
    </main>
  </template>
</template>
